import React, { useEffect } from 'react';

interface WizardStepProps {
  title?: string;
  description?: string;
  children: React.ReactNode;
  isValid?: boolean;
  markStepComplete?: (isValid: boolean) => void;
  className?: string;
}

export const WizardStep: React.FC<WizardStepProps> = ({
  title,
  description,
  children,
  isValid = true,
  markStepComplete,
  className = '',
}) => {
  useEffect(() => {
    markStepComplete?.(isValid);
  }, [isValid, markStepComplete]);

  return (
    <div className={`space-y-4 ${className}`}>
      <div>{children}</div>
    </div>
  );
};
